import { makeGetSelectors } from "@/utils/redux/selector";
import { GLOBAL_STATE_KEY_LIST } from "@/redux/global/slice";

export const { getIsLoading, getTopBar, getApiClient } = makeGetSelectors(
	"global",
	GLOBAL_STATE_KEY_LIST,
);
